<template>
  <div class="row">
    <div class="col-md-7">
      <div class="card">
        <div class="card-body">
          <base-button type="primary" @click="openAddRedeem = true">
            เพิ่มโค๊ดโปรโมชั่น
          </base-button>
          <div class="mt-4">
            <redeem-list-table
              :data="redeems"
              @editRedeem="editRedeem"
              @deleteRedeem="deleteRedeem"
            />
          </div>
        </div>
      </div>
    </div>

    <add-redeem-modal
      :open="openAddRedeem"
      @close="openAddRedeem = false"
      @reload="getRedeems"
    />

    <edit-redeem-modal
      :open="!!viewEditRedeem"
      :redeemInfo="viewEditRedeem"
      @close="viewEditRedeem = null"
      @reload="getRedeems"
    />
  </div>
</template>

<script>
import api from "../services/index";
import RedeemService from "../services/redeem.service";
import RedeemListTable from "../backend-components/Redeem/RedeemListTable";
import AddRedeemModal from "../backend-components/Redeem/AddRedeemModal";
import EditRedeemModal from "../backend-components/Redeem/EditRedeemModal";

export default {
  components: {
    RedeemListTable,
    AddRedeemModal,
    EditRedeemModal,
  },
  data() {
    return {
      loading: false,
      openAddRedeem: false,
      redeems: [],
      viewEditRedeem: null,
    };
  },
  methods: {
    editRedeem(row) {
      this.viewEditRedeem = row;
    },
    deleteRedeem(row) {
      this.loading = true;
      RedeemService.deleteRedeem(row.ID)
        .then(({ message }) => {
          this.$notify({
            type: "success",
            message: message,
          });
          this.getRedeems();
        })
        .catch(({ message }) => {
          this.$notify({ type: "danger", message });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getRedeems() {
      this.loading = true;
      RedeemService.fetchRedeem()
        .then((res) => {
          this.redeems = res;
        })
        .catch(({ message }) => {
          this.$notify({ type: "danger", message });
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  created() {
    this.getRedeems();
  },
};
</script>
